// extracted by mini-css-extract-plugin
export default {"iconContainer":"styles_iconContainer__VBJpK"};